import { Navigate, useParams, useLocation } from "react-router-dom";

/**
 * Permanent client-side redirect for the pre-Task-9 joint order/bid detail path
 * (`/order/multiple/:id`) to its normalised canonical shape (`/orders/multiple/:id`), preserving
 * the query string. Joint links carry `?multipleOrderId=...`, which `EntityIdRedirect` would drop
 * since it only rebuilds the path from `:id`; this instead keeps `id` in the path and forwards
 * `location.search` verbatim, the same way `QueryPreservingRedirect` does for static targets.
 * Same shape as `LegacyPurchaseRequestRedirect` (fixed target, not parameterized like
 * `EntityIdRedirect`'s `to`) because every call site needs the identical `/orders/multiple/:id`
 * target, mounted verbatim across ten role route trees (six buyer, four seller).
 */
const OrderIdQueryRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: `/orders/multiple/${id ?? ""}`, search: location.search }}
      replace
    />
  );
};

export default OrderIdQueryRedirect;
